module.exports = __webpack_public_path__ + "static/media/winmine_1.652c0c53.ico";